import React, { useEffect, useState } from 'react'
import Button from '../../../../component/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';
import ProductInformation from './ProductInformation';
import ProductDisplay from './ProductDisplay';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import BulkFiltrationProduct from './bulkFiltration';
import { BULK_FILTRATION, Filters, TRUCK_SOLUTIONS } from '../../../../helpers';

const ViewProduct = ({ tabName }) => {
    console.log("view product is rendered when edit is pressed")
    const [showDeletePopUp, setShowDeletePopUp] = useState(false)
    const [productData, setProductData] = useState([]);
    const [productImage, setProductImage] = useState([]);
    const navigate = useNavigate()
    const location = useLocation()
    const currentTab = tabName
    const searchParams = new URLSearchParams(location.search);
    const params = searchParams.get('id') || location.search?.split(('?id='))?.at(1)?.split('?')[0];

    const redirectBack = () => {
        navigate('/admin/product-catalog')
    }

    const redirectTo = () => {
        navigate(`?category=${currentTab}?type=edit&refId=${params}`)
    }

    const handleClose = () => {
        setShowDeletePopUp(false)
    }
    const filterDataDelete = async (id) => {
        console.log(id)
        let url = `${Exported.Endpoints.getFilter}/${id}`
        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then((res) => {
            if (res?.data?.status) {
                Toast({
                    type: 'success',
                    message: 'Deleted successfully!'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const truckSolutionDataDelete = async (id) => {
        console.log(id)
        let url = `${Exported.Endpoints.getTruckSolution}/${id}`
        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then((res) => {
            if (res?.data?.status) {
                Toast({
                    type: 'success',
                    message: 'Deleted successfully!'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const deleteProduct = () => {
        if (currentTab === Filters) {
            filterDataDelete(params)
        } else if (currentTab === TRUCK_SOLUTIONS) {
            truckSolutionDataDelete(params)
        }
        setShowDeletePopUp(false)
        redirectBack()
    }

    const getSpecificFilterProduct = async (id) => {
        let url = `${Exported.Endpoints.getFilter}/${id}`
        await request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            console.log(res)
            const response = res?.data?.data
            const filterProductData = [
                { label: "Product ref", value: response?.product_details?.reference_number },
                { label: "Sakura", value: response?.sakura },
                { label: "Hengst", value: response?.hengst },
                { label: "Baldwin", value: response?.baldwin },
                { label: "Fleetguard", value: response?.fleetguard },
                { label: "Hifi", value: response?.hifi },
                { label: "Donaldson", value: response?.donaldson },
                { label: "Mann", value: response?.mann },
                { label: "Wix", value: response?.wix },
                { label: "Retailer Points", value: response?.product_details?.retailer_points },
                { label: "Mechanic Points", value: response?.product_details?.mechanic_points },
                { label: "Application", value: response?.applications?.map((it) => it?.title) || '-' },
                { label: "Sub Category", value: response?.product_details?.product_sub_category?.title },
                response?.quantity != null && { label: "Quantity", value: response?.quantity },
            ];
            const filterImage = [
                { value: response?.product_details?.images }
            ]
            setProductData(filterProductData);
            setProductImage(filterImage)
        }).catch((err) => {
            console.log(err, "err")
        })
    }

    const getSpecificTruckSolutions = async (id) => {
        let url = `${Exported.Endpoints.getTruckSolution}/${id}`
        await request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            const response = res?.data?.data
            const truckSolutionsData = [
                { label: "Product ref", value: response?.product_details?.reference_number },
                { label: "Retailer Points", value: response?.product_details?.retailer_points },
                { label: "Mechanic Points", value: response?.product_details?.mechanic_points },
                { label: "d_mm", value: response?.d_mm },
                { label: "D_mm", value: response?.D__mm },
                { label: "B_mm", value: response?.B_mm },
                { label: "SKF", value: response?.brand_skf?.join(', ') },
                { label: "FAG", value: response?.brand_fag?.join(', ') },
                { label: "Timken", value: response?.brand_timken?.join(', ') },
                { label: "Koyo", value: response?.brand_koyo?.join(', ') },
                { label: "SAF", value: response?.brand_saf?.join(', ') },
                { label: "SNR", value: response?.brand_snr?.join(', ') },
                { label: "Mercedes", value: response?.app_mercedes?.join(', ') },
                { label: "MAN", value: response?.app_man?.join(', ') },
                { label: "Scania", value: response?.app_scania?.join(', ') },
                { label: "DAF", value: response?.app_daf?.join(', ') },
                { label: "Iveco", value: response?.app_iveco?.join(', ') },
                { label: "Volvo", value: response?.app_volvo?.join(', ') },
                { label: "Nissan", value: response?.app_nissan?.join(', ') },
                { label: "Renault", value: response?.app_renault?.join(', ') },
                { label: "Schmitz Cargobull", value: response?.app_schmitz_cargobull?.join(', ') },
            ];
            const truckImage = [
                { value: response?.product_details?.images }
            ]
            setProductData(truckSolutionsData)
            setProductImage(truckImage)
        }).catch((err) => {
            console.log(err, "err")
        })
    }

    const getSpecificBulkFiltration = async (id) => {
        let url = `${Exported.Endpoints.getSpecifiBulkFilter}?id=${id}`
        await request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            console.log(res)
            const response = res?.data?.data
            const bulkFilterData = [
                { label: "Product ref", value: response?.product?.reference_number },
                { label: "Name", value: response?.name },
                { label: "Max Flow Rate", value: response?.max_flow_rate },
                { label: "Working Pressure", value: response?.working_pressure },
                { label: "Rated Static Burst", value: response?.rated_static_burst },
                { label: "Max Viscosity", value: response?.max_viscosity },
                { label: "Mounting Connection", value: response?.mounting_connection },
                { label: "Housing option available", value: response?.housing_option_available === true ? "Yes" : "No" },
                { label: "Retailer Points", value: response?.product?.retailer_points || 0 },
                { label: "Mechanic Points", value: response?.product?.mechanic_points || 0 },

                response?.quantity != null && { label: "Quantity", value: response?.quantity },
            ];
            const bulkProdData = [
                { label: "Product Options", value: response?.product_option?.map((it) => <div><span className='bg-gray-300 mr-3'>{it.label}</span> {it.value}</div>) },
                { label: "Other Options", value: response?.other_option?.map((it) => <div><span className='bg-gray-300 mr-3'>{it.label}</span> {it.value}</div>) },
            ]
            const filterImage = [
                { value: response?.product?.images }
            ]
            setProductData({
                technicalData: bulkFilterData,
                bulkProd: bulkProdData
            });
            setProductImage(filterImage)
        }).catch((err) => {
            console.log(err, "err")
        })
    }

    useEffect(() => {
        if (location?.pathname) {
            if (currentTab === Filters) {
                getSpecificFilterProduct(params)
            } else if (currentTab === TRUCK_SOLUTIONS) {
                getSpecificTruckSolutions(params)
            } else if (currentTab === BULK_FILTRATION) {
                getSpecificBulkFiltration(params)
            }
        }
    }, [location?.pathname])

    return (
        <>
            <div className={``}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex items-center`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>Product Details</div>
                    </div>
                    {currentTab !== BULK_FILTRATION &&
                        <div className='flex items-center'>
                            <Button text={"Delete"} className={`mr-4 !w-[100px]`} smallBtn secondary onClick={() => setShowDeletePopUp(true)} />
                            <Button text={"Edit"} className={`!w-[100px]`} smallBtn onClick={() => redirectTo()} />
                        </div>
                    }
                </div>
                <div className='my-8'>
                    {
                        currentTab === BULK_FILTRATION ? <BulkFiltrationProduct productData={productData} /> : (
                            <ProductInformation productData={productData} />
                        )}
                    <ProductDisplay productImage={productImage} />
                </div>
            </div>
            {showDeletePopUp ?
                <ConfirmationModal
                    isOpen={showDeletePopUp}
                    handleSuccess={deleteProduct}
                    closePopUp={handleClose}
                    warningText={'Confirmation'}
                    modalText={'Are you sure to delete this product?'}
                    confirmText={'Yes'}
                    cancelText={'No'}
                    primaryBtnConfirm={false}
                />
                : null
            }
        </>
    )
}

export default ViewProduct